import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './Legal.css';

function Privacy() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPrivacy();
  }, []);

  const loadPrivacy = async () => {
    try {
      const data = await api.getPrivacy();
      setContent(data);
    } catch (err) {
      console.error('Failed to load privacy:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/login" className="back-link">Back to Login</Link>

        <div className="legal-content">
          <h1>{content?.title || 'Privacy Policy'}</h1>
          <p className="last-updated">Last updated: {content?.lastUpdated}</p>

          <div className="legal-text">
            {content?.content?.split('\n').map((line, i) => {
              if (line.startsWith('# ')) {
                return <h1 key={i}>{line.replace('# ', '')}</h1>;
              }
              if (line.startsWith('## ')) {
                return <h2 key={i}>{line.replace('## ', '')}</h2>;
              }
              if (line.startsWith('### ')) {
                return <h3 key={i}>{line.replace('### ', '')}</h3>;
              }
              if (line.startsWith('- ')) {
                return <li key={i}>{line.replace('- ', '')}</li>;
              }
              if (line.trim() === '') {
                return <br key={i} />;
              }
              return <p key={i}>{line}</p>;
            })}
          </div>
        </div>

        <div className="legal-footer">
          <Link to="/terms">Terms of Service</Link>
          <span>|</span>
          <Link to="/unsubscribe">Delete My Data</Link>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
